import Text from 'components/Text/Text';
import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './AddBtn.module.scss';

export const AddBtn: React.FC = () => {
	return (
		<Link to="/adminSettings/add" data-test="AddBtn">
			<Button
				theme="primaryBlue"
				icon={
					<svg className={style.icon}>
						<use xlinkHref={`${breadcrumbs}#plus`} />
					</svg>
				}>
				<Text translationNameSpace="listing" translationKey="addNewLabelButton" asFragment={true} />
			</Button>
		</Link>
	);
};
